import config from '@project/config';

export const noWhiteSpaceRegex = /^\S+$/;

export const numberOnlyRegex = /^[0-9]*$/;

export const validStringRegex = /^(?!.*\s{2,})(?!^ )[0-9A-Za-z\s,/.'()-]{2,50}$/;

//subsite Themes hashmap
export const subsiteThemes = new Map();
subsiteThemes.set('TR', {
  color: 'green',
});
subsiteThemes.set('4TD', {
  color: 'red',
});
subsiteThemes.set('PLR', {
  color: 'red',
});
subsiteThemes.set('DVR', {
  color: 'yellow',
});
subsiteThemes.set('SLR', {
  color: 'blue',
});
subsiteThemes.set('HOME', {
  color: 'gray',
});
subsiteThemes.set('SAS', {
  color: 'black',
});
subsiteThemes.set('TAR', {
  color: 'purple',
});

export const resourceType = [
  'Teaching Resources',
  'Quality Pedagogy',
  'Mathematical Metacognition',
  'Professional Learning',
  'Enrichment',
  'Problem Solving',
  'Intervention',
];

export const yearLevel = ['Prep', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6'];

export const conceptZone = [
  'Number + Place Value + Addition & Subtraction + Money + Algebra',
  'Multiplication & Division + Fractions + Place Value + Algebra',
  'Fractions + Multiplication & Division + Time + Place Value + Measurement + Geometry',
  'Patterns + Multiplication & Division',
  'Measurement + Geometry + Place Value + Fractions',
];

export const countries = [
  { displayName: 'New South Wales', value: 'New South Wales' },
  { displayName: 'Queensland', value: 'Queensland' },
  { displayName: 'Northern Territory', value: 'Northern Territory' },
  { displayName: 'Western Australia', value: 'Western Australia' },
  { displayName: 'South Australia', value: 'South Australia' },
  { displayName: 'Victoria', value: 'Victoria' },
  { displayName: 'Australian Capital Territory', value: 'Australian Capital Territory' },
  { displayName: 'Tasmania', value: 'Tasmania' },
];

export const otherSearchFilters = [
  {
    id: 'free',
    name: 'Show Free Resources',
  },
  {
    id: 'new',
    name: `Show What's New`,
  },
];

export const subscriptionSidemenuItem = [
  {
    sideMenuId: 'myaccount',
    pathname: ['subscription', 'licenses'],
    items: [
      {
        displayName: 'My Profile',
        urlPath: `${config.subsitesUrl.tr}/subscription/tr/profile`,
        mainPath: 'myprofile',
        color: 'green',
        icon: 'icon icon-circle-user',
      },
      {
        displayName: 'Complete Teaching Resources Subscription Management',
        urlPath: `${config.subsitesUrl.tr}/subscription/tr`,
        mainPath: 'myprofile',
        color: 'green',
        icon: 'icon icon-money',
      },
      {
        displayName: 'Single/Bundled Resources Subscription Management',
        urlPath: 'subscription/invoices',
        mainPath: 'subscription',
        color: 'blue',
        icon: 'fa-regular fa-book-open-cover',
        isCollapsed: true,
        submenu: [
          {
            displayName: 'Invoices',
            urlPath: 'subscription/invoices',
            color: 'blue',
          },
        ],
      },
    ],
  },
];
